import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  { path: '/', name: 'home', component: HomeView },
  {
    path: '/destinations/:id',
    name: 'destination',
    component: () => import('../views/DestinationView.vue'),
  },
  {
    path: '/itineraries',
    name: 'itineraries',
    component: () => import('../views/ItineraryView.vue'),
  },
  {
    path: '/itineraries/:id',
    name: 'itinerary',
    component: () => import('../views/ItineraryDetailView.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue'),
  },
  {
    path: '/plan',
    name: 'plan',
    component: () => import('../views/PlanView.vue'),
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import('../views/BlogView.vue'),
  },
  {
    path: '/blog/:id',
    name: 'article',
    component: () => import('../views/ArticleView.vue'),
  },
  // Unknown paths fall back to the homepage.
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Anchor links scroll to the matching section, offset for the fixed nav.
    if (to.hash) {
      return { el: to.hash, top: 90, behavior: 'smooth' }
    }
    if (savedPosition) return savedPosition
    return { top: 0 }
  },
})

export default router
